import { createFileRoute } from '@tanstack/react-router'

import CreatePnsPppkPage from '@/components/pages/backoffice/_ktg-penyuluh/pns-pppk/_create/containers/CreatePnsPppkPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/pns-pppk/create/'
)({
  component: CreatePnsPppkPage
})
